import React from 'react';
import { Card } from './Card';
export function MapPlaceholder() {
  return <Card className="w-full h-[400px] bg-blue-50 relative overflow-hidden flex items-center justify-center border-2 border-dashed border-blue-200" data-id="element-360">
      <div className="text-center p-6" data-id="element-361">
        <div className="mb-4 opacity-50" data-id="element-362">
          {/* Abstract Map SVG Representation */}
          <svg width="200" height="100" viewBox="0 0 200 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="mx-auto" data-id="element-363">
            <path d="M20 50C20 50 30 20 50 30C70 40 90 20 110 30C130 40 150 30 170 40C190 50 180 80 160 80C140 80 120 70 100 75C80 80 50 90 30 80C10 70 20 50 20 50Z" fill="#CBD5E1" data-id="element-364" />
            <circle cx="50" cy="50" r="4" fill="#2E7D32" data-id="element-365" />
            <circle cx="100" cy="60" r="4" fill="#F9A825" data-id="element-366" />
            <circle cx="150" cy="50" r="4" fill="#C62828" data-id="element-367" />
          </svg>
        </div>
        <h3 className="text-lg font-semibold text-blue-900" data-id="element-368">
          Peta Sebaran Nasional
        </h3>
        <p className="text-sm text-blue-700 max-w-md mx-auto mt-2" data-id="element-369">
          Visualisasi interaktif status pengelolaan sampah per provinsi dan
          kabupaten/kota akan ditampilkan di sini menggunakan PostGIS.
        </p>

        <div className="flex items-center justify-center gap-4 mt-6" data-id="element-370">
          <div className="flex items-center gap-2" data-id="element-371">
            <span className="w-3 h-3 rounded-full bg-green-600" data-id="element-372"></span>
            <span className="text-xs font-medium text-gray-600" data-id="element-373">Baik</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-374">
            <span className="w-3 h-3 rounded-full bg-yellow-500" data-id="element-375"></span>
            <span className="text-xs font-medium text-gray-600" data-id="element-376">
              Perlu Perhatian
            </span>
          </div>
          <div className="flex items-center gap-2" data-id="element-377">
            <span className="w-3 h-3 rounded-full bg-red-600" data-id="element-378"></span>
            <span className="text-xs font-medium text-gray-600" data-id="element-379">
              Bermasalah
            </span>
          </div>
        </div>
      </div>
    </Card>;
}